module.exports = __webpack_public_path__ + "img/services.03b67af1.svg";